import { FormControl, InputLabel, MenuItem, ListItemText, Select as SelectMui } from "@mui/material"
import CheckboxMui from '@mui/material/Checkbox';
import CancelIcon from '@mui/icons-material/Cancel';
import { deleteObligationItem, deleteValueObligationItem, updateObligationItem } from "../Utils/SharedFunctions";
import DeleteIcon from '@mui/icons-material/Delete';
import { IParcelsList } from "components/generics/Interface/Api/Response/Exploitation/Parcels/IParcelsList";
import { IParcelsConstraint } from "components/generics/Interface/Simulation/IParcelsConstraint";

type OrganicObligationParams = {
  organicObligations: IParcelsConstraint[]
  organicObligationItem: IParcelsConstraint
  selectedParcels: IParcelsList[]
  index: number,
  yearsOptions: [{id: number, value: string}],
  setOrganicObligations: (constraints: IParcelsConstraint[])=> {},
  selectedParcelsForConversion: { [index: number]: number[] }
  setSelectedParcelsForConversion: (parcels: { [index: number]: number[] })=> {}
}
export const OrganicObligation = ({ organicObligations, organicObligationItem, selectedParcels, index, yearsOptions, setOrganicObligations, selectedParcelsForConversion, setSelectedParcelsForConversion }: OrganicObligationParams) => {
  const parcelsAvailableForConversion = [...selectedParcels.filter((parcel: IParcelsList) => parcel?.organicState === "conventional" || parcel?.conversionDate === null)]
  const updateObligationItemObligationRestriction = (value: number[] | string, index: number, attr: string) => {
    const { constraints }: {constraints: IParcelsConstraint[]} = updateObligationItem(value, index, attr, organicObligations, yearsOptions);
    if(attr === 'parcel') {
      setSelectedParcelsForConversion({...selectedParcelsForConversion,[index] : [...value as number[]]})
    }
    setOrganicObligations(constraints)
  }
  const checkDisabled = (childId: number) => {
    for (const key in selectedParcelsForConversion) {
      if(+key !== index) {
        return selectedParcelsForConversion[key].includes(childId)
      }
    }
    return false
  }

  return (
    <div className="obligation_and_restriction organic_constraint">
      <div
        className="row_obligation"
        key={'obligation-restriction-' + index}
      >
        <div className="bloc_obligation">
          <label htmlFor="select_parcel" className="label_bloc_obligation">
            Parcelle
          </label>
          <FormControl>
            <InputLabel shrink={false} id="select_parcel_label">
              Sélectionner
            </InputLabel>
            <SelectMui
              sx={{ height: 50, textAlign: 'left' }}
              labelId="select_parcel_label"
              id="select_parcel"
              name="select_parcel"
              multiple
              value={organicObligations?.[index]?.Parcel_Id}
              onChange={(event) =>{
                updateObligationItemObligationRestriction(event.target.value, index, 'parcel')
              }
              }
              renderValue={() => ''}
              MenuProps={{ autoFocus: false }}
            >
              {parcelsAvailableForConversion?.length > 0 &&
                [...parcelsAvailableForConversion].map((child) => (
                  <MenuItem key={child.id} value={child.id} disabled={checkDisabled(child.id)}>
                    <CheckboxMui
                      checked={
                        organicObligations?.[index]?.Parcel_Id.indexOf(
                          child.id
                        ) > -1
                      }
                    />
                    <ListItemText primary={child.name} />
                  </MenuItem>
                ))}
            </SelectMui>
          </FormControl>
          <div className="multi_badge">
            {organicObligationItem?.Parcel_Id?.map((p: number, indexParcel: number) => (
              <span key={indexParcel} className="badge">
                {selectedParcels.find((par: IParcelsList) => par.id === +p)?.name}{' '}
                <span
                  className="delete"
                  onClick={() =>
                    setOrganicObligations(deleteValueObligationItem(index, indexParcel, 'parcels', organicObligations))
                  }
                >
                  <CancelIcon />
                </span>
              </span>
            ))}
          </div>
        </div>
        <div className="bloc_obligation">
          <label htmlFor="select_years" className="label_bloc_obligation">
            Campagne
          </label>
          <FormControl>
            <SelectMui
              sx={{ height: 50 }}
              labelId="select_campagne_label"
              id="select_campagne"
              name="select_years"
              value={organicObligations[index].year}
              onChange={(event) =>
                updateObligationItemObligationRestriction(event.target.value.toString(), index, 'year')
              }
              displayEmpty
              MenuProps={{ autoFocus: false }}
            >
              <MenuItem value="" disabled>
                <em>Campagne</em>
              </MenuItem>
              {[yearsOptions].length > 0 &&
                [...yearsOptions].map((child) => (
                  <MenuItem key={child.value} value={child.id.toString()}>
                    <ListItemText primary={child.value} />
                  </MenuItem>
                ))}
            </SelectMui>
          </FormControl>
        </div>
        <div className="bloc_obligation">
          <span
            className="delete_obligation"
            onClick={() => setOrganicObligations(deleteObligationItem(index, organicObligations))}
          >
            <DeleteIcon sx={{ color: '#eb4d4b', scale: '1.5' }} />
          </span>
        </div>
      </div>
    </div>
  )
}